/**
 * mrpExcel.ts
 *
 * Real Excel (.xlsx) export utility for MRP planning / shortage report.
 */
import * as XLSX from 'xlsx'
import type { MrpPlanningRow } from '../types/mrpTypes'
import { formatIssueInfo, formatSpecDisplay } from './mrpFormatters'

export function buildMrpExcelWorkbook(rows: MrpPlanningRow[]): XLSX.WorkBook {
  const headers = [
    'STT',
    'Mã vật tư',
    'Tên vật tư',
    'Quy cách',
    'ĐVT',
    'Tổng nhu cầu',
    'Đã giữ hàng',
    'Tồn tự do',
    'PO đang về',
    'Lượng thiếu',
    'Đề xuất mua',
    'Nguồn gợi ý',
    'Cảnh báo',
  ]

  const aoa: (string | number)[][] = [headers]

  rows.forEach((r, idx) => {
    let sourceLabel = '—'
    if (r.suggestion_source === 'MRP') sourceLabel = 'Đề xuất mua (MRP)'
    else if (r.suggestion_source === 'POLICY') sourceLabel = 'Định mức tồn (Policy)'
    else if (r.suggestion_source === 'MANUAL') sourceLabel = 'Thủ công'

    const specText = formatSpecDisplay(r.material_spec)
    const issuesText = (r.issues || []).map((code) => formatIssueInfo(code).label).join(', ')

    aoa.push([
      idx + 1,
      r.material_code || '',
      r.material_name || '',
      specText === '—' ? '' : specText,
      r.uom || '',
      r.required_qty,
      r.reserved_qty,
      r.free_unreserved_qty,
      r.incoming_po_qty,
      r.shortage_qty,
      r.recommended_buy_qty,
      sourceLabel,
      issuesText,
    ])
  })

  const ws = XLSX.utils.aoa_to_sheet(aoa)

  ws['!cols'] = [
    { wch: 6 },  // STT
    { wch: 16 }, // Mã vật tư
    { wch: 32 }, // Tên vật tư
    { wch: 24 }, // Quy cách
    { wch: 8 },  // ĐVT
    { wch: 14 }, // Tổng nhu cầu
    { wch: 14 }, // Đã giữ hàng
    { wch: 14 }, // Tồn tự do
    { wch: 14 }, // PO đang về
    { wch: 14 }, // Lượng thiếu
    { wch: 14 }, // Đề xuất mua
    { wch: 22 }, // Nguồn gợi ý
    { wch: 26 }, // Cảnh báo
  ]

  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Thiếu vật tư (MRP)')
  return wb
}

export function exportMrpPlanningToExcel(rows: MrpPlanningRow[]): void {
  const wb = buildMrpExcelWorkbook(rows)
  const todayStr = new Date().toISOString().slice(0, 10)
  const filename = `Báo cáo thiếu vật tư (MRP)_${todayStr}.xlsx`
  XLSX.writeFile(wb, filename)
}
